import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MonCompteComponent } from '@features/compte/mon-compte/containers/mon-compte/mon-compte.component';
import { DarkLightStoreService, DarkLightThemeModule, MenuModule } from 'pu-core-library';
import { VersionService } from 'src/app/shared/services/version/version.service';

@Component({
  standalone: true,
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MonCompteComponent, DarkLightThemeModule, MenuModule, NgClass]
})
export class HeaderComponent {

  @Input() menuDisplay: boolean = false;
  @Input() isLoggedIn: boolean = false;

  version = inject(VersionService);
  formattedVersion = this.version.formattedVersion;
  isSnapshot = this.version.isSnapshot;

  darkLightMode = inject(DarkLightStoreService);


  @Output() menuDisplayChange = new EventEmitter<boolean>();

  openMenu() {
    this.menuDisplay = !this.menuDisplay;
    this.menuDisplayChange.emit(this.menuDisplay);
  }

  get themeMode(): string | null {
    return this.darkLightMode.get('theme')
  }
}
